import React, { Fragment } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { CloseCircle } from 'iconsax-react'
import { useTheme } from '@mui/material'
import { useAppDispatch, useAppSelector } from '@SonarCX/hooks/redux'

import Tooltip from '@SonarCX/components/atoms/Tooltip'

import buttons from './buttonDef'

import {
  selectAllTasksTable,
  clearSelected
} from '@SonarCX/slices/allTasksTable'
import useStyles from './styles'

const TaskMultiEdit: React.FC = () => {
  const theme = useTheme()
  const dispatch = useAppDispatch()

  const { selected } = useAppSelector(selectAllTasksTable)

  const numSelected = React.useMemo(() => selected.length, [selected])

  const classes = useStyles()

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 1 }}
        className={classes.root}
      >
        <div className={classes.numSelected}>
          {numSelected} task{numSelected === 1 ? '' : 's'} selected
        </div>

        <div className={classes.buttons}>
          {buttons.map((group, i) => (
            <Fragment key={i}>
              {group.map(({ key, Comp }) => (
                <Comp key={key} />
              ))}

              {i !== buttons.length - 1 && (
                <div className={classes.separator} />
              )}
            </Fragment>
          ))}
        </div>

        <Tooltip title='Cancel' placement='bottom' arrow>
          <div className={classes.close}>
            <CloseCircle
              variant='Linear'
              size={theme.size.base}
              onClick={() => dispatch(clearSelected())}
            />
          </div>
        </Tooltip>
      </motion.div>
    </AnimatePresence>
  )
}

export default TaskMultiEdit
